import React from 'react';
import css from './lustre.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import java from "../../../assets/images/extra/java-coffee-cup-logo.png";
import lustre from "../../../assets/images/projectsImage/lustre.png";

const Lustre: React.FC = () => (
    <div className={css.project} id="lustre">
        <img src={lustre} alt=""/>
        <div className={css.projectInformationContainer}>
            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>Code Lustre Generator</h3>
            </div>

            <div className={css.info}>
                <Chip label="One Month" variant="outlined" size='small'/>
            </div>
            <div className={css.infoSmallScreen}>
                <Chip label="One Month" variant="outlined" size='small'/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>A Java application that generates <a className={css.link}
                                                                                href='https://www.lustre.org/'
                                                                                rel="noopener noreferrer"
                                                                                target="_blank">lustre</a> code from XML file. Lustre is programming
                language to design critical real-time reactive systems.
            </p>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords}>
                <Tooltip title="Lustre">
                    <Chip label="Lustre" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="XML">
                    <Chip label="XML" color="primary" variant="outlined" size='small'/>
                </Tooltip>
                <Tooltip title="Java">
                    <img src={java} alt=''/>
                </Tooltip>
            </div>
        </div>
    </div>
);

export default Lustre;
